"use client"

import { reatomComponent } from "@reatom/react"
import { ErrorBoundary } from "react-error-boundary"
import { NftsSelectionScopeProvider } from "./nft-selection-scope-provider"

interface Props {
  children: React.ReactNode
}

export const NftsSelectionProvider = reatomComponent<Props>(({ children }) => {
  return (
    <ErrorBoundary fallback={<div>Error loading selection</div>}>
      <NftsSelectionScopeProvider>{children}</NftsSelectionScopeProvider>
    </ErrorBoundary>
  )
}, "NftsSelectionProvider")
